export const validate = (values) => {
  let errors = {}

  if (!values.modulo) errors.modulo = 'Required'
  if (!values.name) errors.name = 'Required'

  return errors
}
